import React from "react";
import '../../styles/common/navigation-dots.scss';

export default function NavigationDots({totalDots, currentIndex}: {totalDots: number, currentIndex: number}) {
  const dots = createDots(totalDots, currentIndex);
  return (
    <div className="navigation-dots">
      {dots}
    </div>
  );
}

const createDots = (totalDots: number, currentIndex: number) => [...Array(totalDots).keys()].map(i => Dot(i === currentIndex, i));

function Dot(isActive: boolean, index: number){
  return <div className={`dot ${isActive ? 'fill': ''}`} key={`dot-${index}`}>&nbsp;</div>;
}